// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.object("UserBattlePass", {
  id: __t.u64(),
  userId: __t.u64(),
  seasonId: __t.u32(),
  currentXp: __t.u64(),
  currentTier: __t.u32(),
  isPremium: __t.bool(),
  claimedFreeTiers: __t.string(),
  claimedPremiumTiers: __t.string(),
});


